import React, { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { logoutUser } from '../../api/api';
import DeleteAccountModal from '../Settings/DeleteAccountModal';

interface SettingsDrawerProps {
  isMobile: boolean;
  show: boolean;
  onClose: () => void;
}

const SettingsDrawer: React.FC<SettingsDrawerProps> = ({ isMobile, show, onClose }) => {
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  if (!isMobile) return null;

  const go = (path: string) => {
    onClose();
    navigate(path);
  };

  const handleLogout = () => {
    onClose();
    logoutUser();
  };

  const handleDelete = () => {
    onClose();
    setShowDeleteModal(true);
  };

  return (
    <>
      <Offcanvas show={show} onHide={onClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Settings</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="d-flex flex-column gap-3">
            <button type="button" className="btn btn-outline-danger" onClick={handleDelete}>
              Account deletion & deactivation
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => go('/notifications')}
            >
              Notifications
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => go('/settings/security')}
            >
              Security
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => go('/settings/privacy')}
            >
              Privacy
            </button>

            <button type="button" className="btn btn-outline-dark" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <DeleteAccountModal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} />
    </>
  );
};

export default SettingsDrawer;
